import React from 'react';
import PropTypes from 'prop-types';
import {
    Text,
    RichText,
    getFieldValue,
    withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import buildClassNames from 'classnames';
import Tier from '../../components-common/Tier';
import Blocks from '../../components-common/Blocks';
import Callout from '../../components-common/Callout';
import {
    COMPONENT_PARAMS,
    getParamValue,
} from '../../utilities/componentParams';
import { COMPONENT_BG_COLOR } from '../../utilities/themeColor';

const FVNUpContentBlock = ({ params, fields }) => {
    const theme = getFieldValue(fields, 'theme');
    const isDarkTheme =
        theme === COMPONENT_BG_COLOR.DARK_GRAY ||
        theme === COMPONENT_BG_COLOR.BLUE;
    const showBottomDivider = getParamValue(
        params[COMPONENT_PARAMS.SHOW_BOTTOM_DIVIDER]
    );
    const showDivider = getParamValue(params[COMPONENT_PARAMS.SHOW_DIVIDER]);
    const isCtaButton = getParamValue(params[COMPONENT_PARAMS.IS_CTA_BUTTON]);

    return (
        <Tier theme={theme} showBottomDivider={showBottomDivider}>
            {getFieldValue(fields, 'heading') && (
                <div className="title title--section">
                    <Text
                        field={fields.heading}
                        tag="h2"
                        className={buildClassNames('hdg hdg--4', {
                            'hdg--fedora': !isDarkTheme,
                        })}
                    />
                </div>
            )}
            {fields?.heading?.value && fields?.body?.value && (
                <div className="vr vr--4x" />
            )}

            {fields?.body?.value && (
                <RichText
                    className={buildClassNames('rich-text', {
                        'rich-text--dark-theme': isDarkTheme,
                    })}
                    field={fields.body}
                />
            )}
            {fields && fields.items && fields.items.length > 0 && (
                <Blocks hasDivider={showDivider} count={fields.items.length}>
                    {fields.items.map((item) => (
                        <div className="blocks__item" key={item.id}>
                            <Callout
                                fields={item.fields}
                                hdgClassNames={buildClassNames({
                                    'hdg hdg--2': fields.items.length === 1,
                                    'hdg hdg--3': fields.items.length > 1,
                                    'hdg--scorpion':
                                        fields.items.length > 1 && !isDarkTheme,
                                })}
                                isCtaButton={isCtaButton}
                                theme={theme}
                            />
                        </div>
                    ))}
                </Blocks>
            )}
        </Tier>
    );
};

FVNUpContentBlock.propTypes = {
    params: PropTypes.shape({
        showBottomDivider: PropTypes.string,
        showDivider: PropTypes.string,
        isCtaButton: PropTypes.string,
    }),
};

FVNUpContentBlock.defaultProps = {
    params: { showBottomDivider: '0', showDivider: '0', isCtaButton: '0' },
};

export default withSitecoreContext()(FVNUpContentBlock);
